export default "__VITE_ASSET__5$9PueCM__"